export default __webpack_public_path__ + "static/media/image.quantalab.afd7832d.png";